import { render, staticRenderFns } from "./ExpertCaseDetail.vue?vue&type=template&id=eab3f84a&scoped=true"
import script from "./ExpertCaseDetail.vue?vue&type=script&lang=js"
export * from "./ExpertCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpertCaseDetail.vue?vue&type=style&index=0&id=eab3f84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab3f84a",
  null
  
)

export default component.exports